import script from "./digital-incorporation-form.vue?vue&type=script&setup=true&lang=js"
export * from "./digital-incorporation-form.vue?vue&type=script&setup=true&lang=js"

import "./digital-incorporation-form.vue?vue&type=style&index=0&id=0de8dea0&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de8dea0"]])

export default __exports__